import grayPfp from "../../../assets/gray.PNG";

const pfp = (img, offset, isOnline) => {
  if (!isOnline) {
    isOnline = false;
  }
  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <img
        src={img ?? grayPfp}
        alt="profile pic"
        style={{
          width: "60px",
          height: "60px",
          minWidth: "60px",
          borderRadius: "50%",
          transform: `translateX(${-offset}px)`,
        }}
      />
      <div
        style={{
          position: "absolute",
          width: "16px",
          height: "16px",
          background: isOnline ? "#25A93A" : "#707070",
          transform: `translateX(calc(${-offset}px + 44px)) translateY(-60px)`,
          border: "2px solid white",
          borderRadius: "50%",
        }}
      ></div>
    </div>
  );
};

export default pfp;
